<template>
  <div>
    <!-- 资源文件 -->
    <Echart
      :options="options"
      id="centerLeftChart"
      height="340px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from '@/common/echart';
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          color: ['#ffcc00'],
          tooltip: {
            //提示框组件
            trigger: 'axis',
            formatter: '{b}<br />{a0}: {c0}',
            axisPointer: {
              type: 'shadow',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // 距离dom四周的距离
          grid: {
            top: '20%',
            left: '60',
            right: '60',
            bottom: '5%',
            containLabel: true
          },

          xAxis: [
            {
              type: 'category',
              data: newData.xAxisData,
              axisLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.12)'
                }
              },
              axisLabel: {
                rotate: 45,
                color: '#e2e9ff',
                textStyle: {
                  fontSize: 14
                }
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
              minInterval: 1,
              axisLabel: {
                textStyle: {
                  color: '#a8aab0',
                  fontSize: 12
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ['#fff'],
                  opacity: 0.06
                }
              }
            }
          ],
          series: [
            {
              name: '数量',
              type: 'bar',
              data: newData.seriesData,
              barWidth: 20,
              barGap: 0, //柱间距离
              label: {
                //图形上的文本标签
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#a8aab0',
                    fontSize: 14
                  }
                }
              },
              itemStyle: {
                //图形样式
                normal: {
                  barBorderRadius: [10, 10, 0, 0]
                }
              }
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
